import { ConstantItems } from "../../constants";
import { Constants } from "../../constants";
import { FileItems } from "./FileItems";
import * as angular from "angular";

export class OnboardingRepo {
  static $inject = ["$http", "config"];
  public bucket: string;
  public env: string;

  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems,
    private configConstants: Constants
  ) {
    this.bucket = Constants.getDocumentBucket();
    this.env = Constants.getEnvironment();
  }
  getFiles() {
    return this.$http
      .get(`${this.config.fileUrl}/getAccountForm/${this.bucket}`)
      .then((resp) => resp.data as FileItems[]);
  }

  getOpenFiles(client, hash) {
    return this.$http
      .post(
        `${this.config.fileUrl}/getAnonAccountForm/${this.bucket}/${client}`,
        { value: hash }
      )
      .then((resp) => resp.data as FileItems[]);
  }

  getClients() {
    return this.$http
      .get(`${this.config.fileUrl}/getAllClients/${this.bucket}`)
      .then((resp) => resp.data as string[]);
  }

  getClientFiles(client) {
    return this.$http
      .get(`${this.config.fileUrl}/getClientForm/${this.bucket}/${client}`)
      .then((resp) => resp.data as FileItems[]);
  }

  getOpenClientFiles(client, hash) {
    return this.$http
      .post(
        `${this.config.fileUrl}/getAnonClientForm/${this.bucket}/${client}`,
        { value: hash }
      )
      .then((resp) => resp.data as FileItems[]);
  }

  uploadFile(file) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.$http
      .post(
        `${this.config.fileUrl}/uploadAccountForm/${this.bucket}`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identity,
        }
      )
      .then((resp) => resp.data as any);
  }

  uploadClientFile(file, client) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.$http
      .post(
        `${this.config.fileUrl}/uploadClientForm/${this.bucket}/${client}`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identity,
        }
      )
      .then((resp) => resp.data as any);
  }

  uploadOpenClientFile(file, client, hash) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.$http
      .post(
        `${this.config.fileUrl}/uploadAnonClientForm/${this.bucket}/${client}/${hash}`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identity,
        }
      )
      .then((resp) => resp.data as any);
  }

  deleteFile(file) {
    return this.$http
      .post(`${this.config.fileUrl}/deleteAccountForm/${this.bucket}`, {
        value: file,
      })
      .then((resp) => resp.data);
  }

  deleteAnonFile(file, client, hash) {
    return this.$http
      .post(
        `${this.config.fileUrl}/deleteAnonAccountForm/${this.bucket}/${client}/${hash}`,
        {
          value: file,
        }
      )
      .then((resp) => resp.data);
  }

  requestOtp(email) {
    return this.$http
      .post(`${this.config.userUrl}/generateotp/${this.env}`, {
        emailAddress: email,
      })
      .then((resp) => resp.data as string);
  }

  verifyOtp(email, otp) {
    return this.$http
      .post(`${this.config.userUrl}/verifyotp`, {
        emailAddress: email,
        OTP: otp,
      })
      .then((resp) => resp.data as string);
  }

  sendStatusUpdate(email, status) {
    return this.$http
      .post(`${this.config.userUrl}/statusUpdate/${this.env}/${email}`, {
        value: status,
      })
      .then((resp) => resp.data as string);
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/onboarding.repo.ts